/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * ZandaHealth API
 * OpenAPI spec version: 1.0
 */

export type ClientPortalPaymentModes =
  (typeof ClientPortalPaymentModes)[keyof typeof ClientPortalPaymentModes];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ClientPortalPaymentModes = {
  Disabled: 0,
  Optional: 1,
  Required: 2,
} as const;
